import { Col, Card } from "react-bootstrap"
import Link from "next/link"
import { StyleCard } from "@styled/skills"
import { StudentSkillsQuery } from "@generated/graphql"

interface Props {
  skill: StudentSkillsQuery["studentSkills"][0]
}

export default function SkillComponent(props: Props) {
  const { skill: { name, featuredImage, slug } } = props
  const imgSrc = featuredImage || "/assets/img/logo.png"
  return (
    <Col className="bg-white rounded-lg mb-4">
      <Link href={`/skills/${slug}`} legacyBehavior>
        <StyleCard>
          <Card.Img variant="top" src={imgSrc} style={{ margin: "0 auto", maxHeight: 250, maxWidth: 250, minHeight: 250, minWidth: 250, pointerEvents: "none" }} />
          <Card.Body className="p-2">
            <Card.Title>
              <h4><b>{name}</b></h4>
            </Card.Title>
          </Card.Body>
        </StyleCard>
      </Link>
    </Col>
  )
}
